import Model, { attr } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('billing-v1')
class HostedPage extends Model {
  @attr('string') url;
  @attr('string') companyId;
}

export default HostedPage;
